import { render, staticRenderFns } from "./simLogisticRecord.vue?vue&type=template&id=31bf6d4c&scoped=true"
import script from "./simLogisticRecord.vue?vue&type=script&lang=js"
export * from "./simLogisticRecord.vue?vue&type=script&lang=js"
import style0 from "./simLogisticRecord.vue?vue&type=style&index=0&id=31bf6d4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf6d4c",
  null
  
)

export default component.exports